import './MapView.scss'
import React from "react";
import Map from '../components/map/Map';
import MobileLanding from "../components/MobileLanding";
import { getPlatform } from "../helpers/platform";
import InitialViewport from "../components/map/InitialViewport";
import UserLocationMarker from "../components/map/UserLocationMarker";
import GoToUserLocationControl from "../components/map/controls/GoToUserLocationControl";
import MapStyleControl from "../components/map/controls/MapStyleControl";
import AllowLocationAccessControl from "../components/map/controls/AllowLocationAccessControl";
import LocationErrorControl from "../components/map/controls/LocationErrorControl";
import TerritoryLayer from "../components/map/layers/TerritoryLayer";
import TilesLayer from "../components/map/layers/TilesLayer";
import SparkleOverlay from "../components/map/layers/SparkleOverlay";
import MessagesLayer from "../components/map/layers/MessagesLayer";
import GridLayer from "../components/map/layers/GridLayer";
import SignInModal from "../components/auth/SignInModal";
import SignInButton from "../components/auth/SignInButton";
import AppBanner from "../components/AppBanner";
import TilesLoadingIndicator from "../components/map/controls/TilesLoadingIndicator";
import ForumNavLink from "../components/ForumNavLink";

const MapView = () => {
    // Phone visitors get a static store-funnel landing — never the live map.
    // The map (and its WebGL/Firestore cost) is desktop-only.
    if (getPlatform() !== 'other') {
        return <MobileLanding />;
    }

    return (
        <>
            <Map>
                <InitialViewport />
                <GridLayer />
                {/* TerritoryLayer MUST be before TilesLayer — z-order intentional.
                    map.addLayer() order controls Mapbox layer stack; territory sits below tiles. */}
                <TerritoryLayer />
                <TilesLayer />
                <SparkleOverlay />
                {/* MessagesLayer MUST be after TilesLayer — z-order intentional.
                    Player messages render on top of painted tiles. */}
                <MessagesLayer />
                <AllowLocationAccessControl />
                <LocationErrorControl />
                <UserLocationMarker/>
                <MapStyleControl />
                <GoToUserLocationControl />
            </Map>
            <TilesLoadingIndicator />
            <SignInModal />
            <SignInButton />
            <ForumNavLink />
            <AppBanner />
        </>
    );
}

export default MapView;
